import React from 'react'
import Navbar from '../NavBar/Navbar'
import PdfPage from './PdfPage'
const PdfPageMain = () => {
  return (
    <div>
        <Navbar/>
        <PdfPage/>
        
    </div>
  )
}

export default PdfPageMain